import React from 'react';
import logo from './logo.svg';
import './App.css';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import CustomerForm from './components/Customer/CustomerForm';
import SellerForm from './components/Seller/SellerForm';
import { BrowserRouter as Router,Routes, Route, Link } from "react-router-dom";
import OnboardForms from './components/OnboardForms';
import Login from './components/Login/Login';

function App() {
  return (
	<div>
	<Header></Header>
	<Routes>
		<Route path="/onboard/login" element={<Login/>} />
		<Route path="/onboard" element={<OnboardForms/>} />	
	 	<Route path="onboard/customer" element={<CustomerForm/>} />		
	 	<Route path="onboard/seller" element={<SellerForm/>} />		
		{/* <Route path="onboard/customer" element={<OnboardForms/>} />		
	 	<Route path="onboard/seller" element={<OnboardForms/>} /> */}
	</Routes>
	<Footer></Footer>
	</div>
	
  );
}

export default App;
